import { render, staticRenderFns } from "./mainheader.vue?vue&type=template&id=f33b2d12"
import script from "./mainheader.vue?vue&type=script&lang=js"
export * from "./mainheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports